<div class="product-list-filters-container">

  <div class="filter-toggle-container" [innerHTML]="getToggleTxt()" (click)="isFiltersHidden = !isFiltersHidden"></div>

  <div [hidden]="isFiltersHidden">
    
    <div class="row">
      
      <div class="col-sm-4">
        <div class="combo-box-container">
          <select class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedFilters.maxRiskGrade" (change)="applyFitler()">
            <option [value]="null" hidden>Rischio max</option>
            <option [value]="null">--nessuno--</option>
            @for(item of maxRiskGradeFilters; track item) {
              <option [value]="item">{{item}}</option>
            }
          </select>
        </div>
      </div>
  
      <div class="col-sm-4">
        <div class="combo-box-container">
          <select class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedFilters.minPremium" (change)="applyFitler()">
            <option [value]="null" hidden>Premio min.</option>
            <option [value]="null">--nessuno--</option>
            @for(item of minPremiumFilters; track item) {
              <option [value]="item">{{item | number}}</option>
            }
          </select>
        </div>
      </div>
  
      <div class="col-sm-4">
        <div class="combo-box-container">
          <select class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedFilters.investTrgt" (change)="applyFitler()">
            <option [value]="null" hidden>Obiett. invest.</option>
            <option [value]="null">--nessuno--</option>
            @for(item of investTrgtFilters; track item) {
              <option [value]="item">{{item}}</option>
            }
          </select>
        </div>
      </div>
  
    </div>
  
    <div class="row">
  
      <div class="col-sm-4">
        <div class="combo-box-container">
          <div class="multiple-select-btn">
            <app-btn padding="6px 12px" txtAlign="left" (click)="openMultipleSelectionModal('companies')"><p class="multi-select-txt">Compagnie ({{selectedFilters.companies?.length ?? 0}} attiv{{selectedFilters.companies?.length == 1 ? 'o' : 'i'}})</p></app-btn>
          </div>
        </div>
      </div>
  
      <div class="col-sm-4">
        <div class="combo-box-container">
          <div class="multiple-select-btn">
            <app-btn padding="6px 12px" txtAlign="left" (click)="openMultipleSelectionModal('ramoVita')"><p class="multi-select-txt">Ramo Vita ({{selectedFilters.ramiVita?.length ?? 0}} attiv{{selectedFilters.ramiVita?.length == 1 ? 'o' : 'i'}})</p></app-btn>
          </div>
        </div>
      </div>
  
      <div class="col-sm-4">
        <div class="combo-box-container">
          <select class="form-select comparatoreMF-box-shadow" [(ngModel)]="selectedFilters.suggPeriod" (change)="applyFitler()">
            <option [value]="null" hidden>Durata raccomandata</option>
            <option [value]="null">--nessuno--</option>
            @for(item of suggPeriodFilters; track item) {
              <option [value]="item">{{item}}</option>
            }
          </select>
        </div>
      </div>
  
    </div>

    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-4">
        <div class="filter-btn-container" [hidden]="getNActiveFilters() == 0">
          <app-btn (click)="removeAllFilters()" txtAlign="center" color="mf-primary" padding="6px 24px">
            <span>Rimuovi filtri</span>
          </app-btn>
        </div>
      </div>
      <div class="col-sm-4"></div>
    </div>

  </div>

</div>